import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Tick(props) {
  if (props.visible) {
    return (
      <Svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M8.24156 13.7559L5.24421 10.7595C4.9186 10.434 4.9186 9.90819 5.24421 9.58268C5.56983 9.25717 6.09583 9.25717 6.42144 9.58268L8.83435 11.9864L14.5786 6.24413C14.9042 5.91862 15.4302 5.91862 15.7558 6.24413C16.0814 6.56964 16.0814 7.09546 15.7558 7.42097L9.41879 13.7559C9.10152 14.0814 8.56717 14.0814 8.24156 13.7559Z"
          fill={props.fill || "#00AB59"}
          stroke={props.fill || "#00AB59"}
        />
      </Svg>
    );
  }
  return null;
}

export default Tick;
